import { Component, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import { AttendanceService } from 'src/app/shared/services/attendanceservices/attendance.service';
import { FormsModule, NgForm } from '@angular/forms';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { LeaveService } from 'src/app/shared/services/leaveservices/leave.service';
import { CommonModule, DatePipe } from '@angular/common';
import { Location } from '@angular/common';
import moment from 'moment';
import Swal from 'sweetalert2';
import { Router, RouterModule } from '@angular/router';
import { calculateUpdatedTime } from '../shift-time';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { DeviceUuidService } from 'src/app/shared/services/deviceuuidservices/device-uuid.service';
import { environment } from 'src/environments/environment';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { AttendanceTypeComponent } from '../sub-component/attendance-type/attendance-type.component';


@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule, AttendanceTypeComponent],
  providers: [DatePipe],
})
export class MainComponentAttendance implements OnInit {

  typeArr: any = [];
  public overtime: any = '';
  public workingHours: any = '';
  public stats: any = [];
  public checkInStatus: any = '';
  public checkStats = false;
  public checkInTime: any = '';
  public user: any = [];
  public leaves: any[] = [];
  public paidLeaves: any[] = [];
  public unpaidLeaves: any[] = [];
  public actionattendance: any[] = [];
  public showSpinner = true;
  public startdate: string | null;
  public endDate: string | null;
  public filterType = "";
  public filterMonth = "";
  public topState: any[] = [];
  shiftRemainingTime = "00:00:00";
  percentageInProgress = 100;
  checkInArrayForGraph: any[] = [];
  checkOutArrayForGraph: any[] = [];
  checkInChartData: any = {};
  checkOutChartData: any = {};
  checkInData: any[] = [];
  checkOutData: any[] = [];
  isPrintPage = false;
  printingContent: any = {};
  checkInDays: any[] = [];
  checkOutDays: any[] = [];
  secondShitEmployees = [46, 55, 60, 63, 61, 73, 112];
  checkOutDate: any;
  totalHours = 0;
  checkOutTime = "";
  checkInDate: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  refresh: any;
  latitude = 0;
  longitude = 0;
  errorMessage: string | null = null;
  org_lat: any;
  org_long: any;
  deviceUuid: any;
  att_shift_start_time: any;
  att_shift_end_time: any;
  att_total_hours: any;
  multiple_push: any;
  initialTime: any;
  latest_start_time: any;
  latest_end_time: any;
  user_shift_start_time: any;
  user_shift_end_time: any;
  user_total_hours: any;
  latest_total_hours: any;
  constructor(
    private attendanceService: AttendanceService,
    private leaveService: LeaveService,
    public router: Router,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
    private deviceUuidService: DeviceUuidService,
    private _location: Location,
    public datepipe: DatePipe
  ) {
    const date = new Date();
    this.startdate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd');
    this.endDate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth() + 1, 0), 'yyyy-MM-dd');
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();
  }

  ngOnInit(): void {
    // this.getLocation();
    this.deviceUuid = localStorage.getItem("userDeviceID_OneSignal_subcripptio")
    $('.attendance-d a').removeClass('active');
    $(this).addClass('active');

    $('.circle_animation').css('stroke-dashoffset', 1);
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
    this.user_refresh();
    this.getLeaves();
    this.checkTimer();
    this.getAttendanceStats();

  }
  getImageURL(latitude: number, longitude: number): any {
    if ((latitude ?? 0) == 0 || (longitude ?? 0) == 0) {
      return '../../../../assets/images/no_Location.png'
    } else {
      return `https://maps.google.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=17&size=640x480&scale=4&markers=size:large%7Ccolor:orange%7C${latitude},${longitude}&key=${environment.GoogleMapKey}`
    }
  }
  user_refresh() {
    this.dashboardService.getuserrefresh().then((value) => {
      this.refresh = value?.data?.user
      this.user = this.refresh;
      this.multiple_push = this.refresh.multiple_punch
      this.user_shift_start_time = this.user.shift_start_time;
      this.user_shift_end_time = this.user.shift_end_time;
      this.user_total_hours = this.user?.total_working_hours
      this.org_lat = this.refresh.organization?.address?.latitude ?? 0;
      this.org_long = this.refresh.organization?.address?.longitude ?? 0;
      this.latest_start_time = this.user?.usershittime?.[0]?.start_time;
      this.latest_end_time = this.user?.usershittime?.[0]?.end_time;
      this.latest_total_hours = this.user?.usershittime?.[0]?.total_working_hours;


      this.att_shift_start_time = this.latest_start_time ?? this.user_shift_start_time;
      this.att_shift_end_time = this.latest_end_time ?? this.user_shift_end_time;
      this.att_total_hours = this.latest_total_hours ?? this.user_total_hours;

    })

  }



  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }


  convertIntoSeconds(time: any) {
    const parts = time.split(':');
    return parts[0] * 3600 + parts[1] * 60;
  }

  getCurrentPosition(): Promise<{ latitude: number, longitude: number }> {
    return new Promise((resolve, reject) => {

      if (navigator.geolocation) {

        navigator.geolocation.getCurrentPosition((position) => {
          const coords = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          };
          resolve(coords);
        }, (error) => {
          console.error('Geolocation error:', error);
          reject(error);
        });
      } else {
        reject(new Error('Geolocation is not supported by this browser.'));
      }
    });
  }

  isAvaialbaletoCheckin(): boolean {
    const checkout_count = this.checkOutTime?.length ?? 0
    const checkin_count = this.checkInTime?.length ?? 0
    if ((checkin_count == 0) && (checkout_count == 0) && (this.userInfo.attandance_type != 'Normal')) {
      return true;
    } else if ((checkin_count > 0) && (checkout_count > 0) && this.multiple_push == 'Yes') {
      return true;
    } else {
      return false;
    }

  }

  isAvaialbaletoCheckOut(): boolean {
    const checkin_count = this.checkInTime?.length ?? 0
    const checkout_count = this.checkOutTime?.length ?? 0
    if ((checkin_count > 0) && (checkout_count == 0) && (this.userInfo.attandance_type != 'Normal')) {
      return true;
    } else {
      return false;
    }
  }

  getCheckInDetail() {
    if (this.isAvaialbaletoCheckin()) {
      this.showSpinner = true
      this.getCurrentPosition().then((coords) => {
        this.showSpinner = false
        this.latitude = coords.latitude;
        this.longitude = coords.longitude;
        const currentDate = new Date();
        const mn = currentDate.getMonth() + 1
        const month = (mn < 10) ? `0${mn}` : (mn)
        const checkInTime = `${currentDate.getHours()}:${currentDate.getMinutes() < 10 ? "0" + currentDate.getMinutes() : currentDate.getMinutes()}`;
        if (this.checkInDate == null || this.checkInDate == undefined || this.checkInDate == '') {
          this.checkInDate = `${currentDate.getFullYear()}/${month}/${currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate()}`;
        } else {
          this.checkInDate = this.checkInDate
        }

        Swal.fire({
          iconHtml: `    <div style="text-align: center;">
            <img
                style="width: 100% !important;"
                src="${this.getImageURL(this.latitude, this.longitude)}"
                alt="image"
                onerror="this.onerror=null;this.src='../../../../assets/images/Info_icon.svg';"
            >`,
          title: 'Do you really want to check In?',
          text: `Your Check In Time is  :  ${checkInTime} `,
          showCancelButton: true,
          confirmButtonText: "Yes, Check In",
          showConfirmButton: true,
          cancelButtonText: "Not Now"
        }).then((checkout: any) => {
          if (checkout.value) {

            const model = {

              date: this.checkInDate,
              check_in: checkInTime,
              latitude: this.latitude,
              longitude: this.longitude,
              org_lat: this.org_lat,
              org_long: this.org_long,
              // device_id: "D3FE1439-321A-4025-B864-EEA89DDC9EF" ,
              device_id: this.deviceUuid,
              location: "Lahore",
              is_portal: 1,
              user_id: this.user.id,
              attendance_type_id: 4,
              lunch_id: 1,
              source: "web_portal",

            };
            this.checkIn(model);

          }
        });
      }).catch((error) => {
        this.showSpinner = false
        this.errorMessage = error.message;
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/Info_icon.svg"  alt="image" >',
          title: `We are not able to get your Current Location, please try again!`,
          showConfirmButton: false,
          timer: 2000,
        })
      });
    } else {
      Swal.fire({
        iconHtml: ' <img src="../../../../assets/images/Info_icon.svg"  alt="image" >',
        title: `Check In Already Applied First do Check Out `,
        showConfirmButton: false,
        timer: 2000,
      })
    }
  }

  // getCheckInDetail() {
  //   if (this.isAvaialbaletoCheckin()) {
  //     this.showSpinner = true;

  //     // Check if geolocation is available in the browser
  //     if (navigator.geolocation) {
  //       navigator.geolocation.getCurrentPosition(
  //           (position) => {

  //               this.latitude = position.coords.latitude;
  //               this.longitude = position.coords.longitude;
  //           },
  //           (error) => {
  //               switch (error.code) {
  //                   case error.PERMISSION_DENIED:
  //                       // User denied the location access
  //                       // alert("Location services are off. Please enable location access.");
  //                       break;
  //                   case error.POSITION_UNAVAILABLE:
  //                       // alert("Unable to retrieve your location.");
  //                       break;
  //                   case error.TIMEOUT:
  //                       // alert("Location request timed out. Please try again.");
  //                       break;
  //                   default:
  //                       // alert("An unknown error occurred. Please try again.");
  //                       break;
  //               }
  //               this.latitude = 0;
  //               this.longitude = 0;
  //           }
  //       );
  //   } else {
  //       this.latitude = 0;
  //       this.longitude = 0;
  //   }
  //     let currentDate = new Date();
  //     let mn = currentDate.getMonth() + 1;
  //     let month = (mn < 10) ? `0${mn}` : mn;
  //     let checkInTime = `${currentDate.getHours()}:${currentDate.getMinutes() < 10 ? "0" + currentDate.getMinutes() : currentDate.getMinutes()}`;

  //     if (this.checkInDate == null || this.checkInDate == undefined || this.checkInDate == '') {
  //       this.checkInDate = `${currentDate.getFullYear()}/${month}/${currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate()}`;
  //     }
  //     this.showSpinner = false;
  //     Swal.fire({
  //       iconHtml: `
  //         <div style="text-align: center;">
  //           <img
  //             style="width: 100% !important;"
  //             src="${this.latitude && this.longitude ? this.getImageURL(this.latitude, this.longitude) : 'default_image_url'}"
  //             alt="image"
  //             onerror="this.onerror=null;this.src='../../../../assets/images/Info_icon.svg';"
  //           >
  //         </div>`,
  //       title: 'Do you really want to check In?',
  //       text: `Your Check In Time is : ${checkInTime}`,
  //       showCancelButton: true,
  //       confirmButtonText: "Yes, Check In",
  //       cancelButtonText: "Not Now"
  //     }).then((checkout) => {
  //       if (checkout.value) {
  //         let model = {
  //           date: this.checkInDate,
  //           check_in: checkInTime,
  //           latitude: this.latitude,
  //           longitude: this.longitude,
  //           org_lat: this.org_lat,
  //           org_long: this.org_long,
  //           device_id: this.deviceUuid,
  //           location: "Lahore", // Set default location if needed
  //           is_portal: 1,
  //           user_id: this.user.id,
  //           attendance_type_id: 4,
  //           lunch_id: 1,
  //           source: "web_portal",
  //         };
  //         this.checkIn(model);
  //       }
  //     });
  //   } else {
  //     Swal.fire({
  //       iconHtml: ' <img src="../../../../assets/images/Info_icon.svg" alt="image" >',
  //       title: `Check In Already Applied First do Check Out `,
  //       showConfirmButton: false,
  //       timer: 2000,
  //     });
  //   }
  // }

  // getCheckOutDetail() {

  //   this.showSpinner = true;
  //   this.dashboardService.getTodayCheckIn().then((value) => {
  //     this.showSpinner = false;
  //     this.checkInDate = value?.data?.date;
  //     this.checkInTime = value?.data?.check_in;
  //     this.checkOutTime = value?.data?.check_out;

  //     if (this.isAvaialbaletoCheckOut()) {
  //       this.showSpinner = true;
  //       // Geolocation check
  //       if (navigator.geolocation) {
  //         navigator.geolocation.getCurrentPosition(
  //             (position) => {
  //                 this.latitude = position.coords.latitude;
  //                 this.longitude = position.coords.longitude;
  //             },
  //             (error) => {
  //                 switch (error.code) {
  //                     case error.PERMISSION_DENIED:
  //                         break;
  //                     case error.POSITION_UNAVAILABLE:
  //                         break;
  //                     case error.TIMEOUT:
  //                         break;
  //                     default:
  //                         break;
  //                 }
  //                 this.latitude = 0;
  //                 this.longitude = 0;
  //             }
  //         );
  //     } else {
  //         this.latitude = 0;
  //         this.longitude = 0;
  //     }
  //       let currentDate = new Date();
  //       let mn = currentDate.getMonth() + 1;
  //       let month = (mn < 10) ? `0${mn}` : mn;
  //       let checkOutTime = `${currentDate.getHours()}:${currentDate.getMinutes() < 10 ? "0" + currentDate.getMinutes() : currentDate.getMinutes()}`;
  //       this.checkOutDate = `${currentDate.getFullYear()}/${month}/${currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate()}`;

  //       if (this.checkInTime != "") {
  //         this.totalHours = Math.abs(new Date(`${this.checkOutDate} ${checkOutTime}`).getTime() - new Date(`${this.checkInDate} ${this.checkInTime}`).getTime()) / 36e5;
  //         this.totalHours = this.totalHours < 0 ? this.totalHours * (-1) : this.totalHours;
  //       }
  //       this.showSpinner = false;
  //       Swal.fire({
  //         iconHtml: `
  //           <div style="text-align: center;">
  //             <img
  //               style="width: 100% !important;"
  //               src="${this.latitude && this.longitude ? this.getImageURL(this.latitude, this.longitude) : 'default_image_url'}"
  //               alt="image"
  //               onerror="this.onerror=null;this.src='../../../../assets/images/Info_icon.svg';"
  //             >
  //           </div>`,
  //         title: 'Do you really want to check out?',
  //         text: `Your Check Out Time is: ${checkOutTime}`,
  //         showCancelButton: true,
  //         confirmButtonText: "Yes, Check Out",
  //         cancelButtonText: "Not Now"
  //       }).then((checkout:any) => {
  //         if (checkout.value) {
  //           let model = {
  //             date: this.checkInDate,
  //             check_out: checkOutTime,
  //             check_in: "",
  //             total_hours: this.totalHours != 0 ? this.totalHours.toFixed(2) : 0,
  //             latitude: this.latitude,
  //             longitude: this.longitude,
  //             org_lat: this.org_lat,
  //             org_long: this.org_long,
  //               // device_id: "D3FE1439-321A-4025-B864-EEA89DDC9EF",
  //             device_id: this.deviceUuid,
  //             location: "Lahore", // Set default location if needed
  //             is_portal: 1,
  //             user_id: this.user.id,
  //             attendance_type_id: 4,
  //             lunch_id: 1,
  //             source: "web_portal",
  //           };
  //           this.checkOut(model);
  //         } else {
  //           Swal.fire({
  //             iconHtml: ' <img src="../../../../assets/images/Info_icon.svg" alt="image" >',
  //             title: `You Are Not in Range`,
  //             showConfirmButton: false,
  //             timer: 2000,
  //           });
  //         }
  //       });
  //     } else {
  //       this.showSpinner = false;
  //       Swal.fire({
  //         iconHtml: ' <img src="../../../../assets/images/Info_icon.svg" alt="image" >',
  //         title: `You are not allowed to check out at this moment, Please Check In First, Thanks.`,
  //         showConfirmButton: false,
  //         timer: 2000,
  //       });
  //     }
  //   }).catch((error) => {
  //     this.showSpinner = false;
  //     Swal.fire({
  //       iconHtml: ' <img src="../../../../assets/images/Info_icon.svg" alt="image" >',
  //       title: `Error fetching check-in details`,
  //       showConfirmButton: false,
  //       timer: 2000,
  //     });
  //   });
  // }

  getCheckOutDetail() {
    this.showSpinner = true;
    this.dashboardService.getTodayCheckIn().then((value) => {
      this.showSpinner = false
      this.checkInDate = value?.data?.date;
      this.checkInTime = value?.data?.check_in;
      this.checkOutTime = value?.data?.check_out;
      if (this.isAvaialbaletoCheckOut()) {

        this.getCurrentPosition().then((coords) => {
          this.showSpinner = false;
          if (coords) {
            this.latitude = coords.latitude;
            this.longitude = coords.longitude;
          } else {
            // If no location, set default or empty
            this.latitude = 0;
            this.longitude = 0;
          }
          // this.latitude = coords.latitude;
          // this.longitude = coords.longitude;
          const currentDate = new Date();
          const mn = currentDate.getMonth() + 1
          const month = (mn < 10) ? `0${mn}` : (mn)
          const checkOutTime = `${currentDate.getHours()}:${currentDate.getMinutes() < 10 ? "0" + currentDate.getMinutes() : currentDate.getMinutes()}`;
          this.checkOutDate = `${currentDate.getFullYear()}/${month}/${currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate()}`;
          if (this.checkInTime != "") {
            this.totalHours = Math.abs(new Date(`${this.checkOutDate} ${checkOutTime}`).getTime() - new Date(`${this.checkInDate} ${this.checkInTime}`).getTime()) / 36e5;
            this.totalHours = this.totalHours < 0 ? this.totalHours * (-1) : this.totalHours;
          }
          Swal.fire({
            // iconHtml: ` <img style='width: 100% !important;' src=${this.getImageURL(this.latitude, this.longitude)}  alt="image" onerror="this.onerror=null;this.src='../../../../assets/images/Info_icon.svg'; >`,
            iconHtml: `    <div style="text-align: center;">
            <img
                style="width: 100% !important;"
                src="${this.getImageURL(this.latitude, this.longitude)}"
                alt="image"
                onerror="this.onerror=null;this.src='../../../../assets/images/Info_icon.svg';"
            >`,
            title: 'Do you really want to check out?',
            text: `Your Check Out Time is  :  ${checkOutTime} `,
            showCancelButton: true,
            confirmButtonText: "Yes, Check Out",
            showConfirmButton: true,
            cancelButtonText: "Not Now"
          }).then((checkout: any) => {
            if (checkout.value) {
              const model = {
                date: this.checkInDate,
                check_out: checkOutTime,
                check_in: "",
                total_hours: this.totalHours != 0 ? this.totalHours.toFixed(2) : 0,
                latitude: this.latitude,
                longitude: this.longitude,
                org_lat: this.org_lat,
                org_long: this.org_long,
                // device_id: "D3FE1439-321A-4025-B864-EEA89DDC9EF",
                device_id: this.deviceUuid,
                location: "Lahore",
                is_portal: 1,
                user_id: this.user.id,
                attendance_type_id: 4,
                lunch_id: 1,
                source: "web_portal",
              };
              this.checkOut(model);
            }
            else if (checkout.value == false) {
              Swal.fire({
                iconHtml: ' <img src="../../../../assets/images/Info_icon.svg"  alt="image" >',
                title: `You Are Not in Range`,
                showConfirmButton: false,
                timer: 2000,
              })
            }
          });
        }).catch((error) => {
          this.showSpinner = false
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/Info_icon.svg"  alt="image" >',
            title: `We are not able to get your Current Location, please try again!`,
            showConfirmButton: false,
            timer: 2000,
          })
        });
      }
      else {
        this.showSpinner = false
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/Info_icon.svg"  alt="image" >',
          title: `You are not allowed to check out at this moment, Please Check In First, Thanks.`,
          showConfirmButton: false,
          timer: 2000,
        })
      }
    })
  }

  checkOut(model: any) {
    this.showSpinner = true
    this.dashboardService.checkOutFromPortal(model).then((result) => {
      if (result.success) {
        this.showSpinner = false
        Swal.fire({
          iconHtml: ' <img style="width="240"; height="240" src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: result.message,
          showConfirmButton: false,
          timer: 2000,
        })
        this.showSpinner = false
        window.location.reload();
      }
      else {
        Swal.fire({
          iconHtml: '<img style="width="240"; height="240" src="../../../../assets/images/modal-close.svg"  alt="image" >',
          title: result.message,
          showConfirmButton: false,
          timer: 2000,
        })
        this.showSpinner = false
      }
    });
  }

  checkIn(model: any) {
    this.showSpinner = true
    this.dashboardService.checkInFromPortal(model).then((result) => {
      if (result.success) {
        this.showSpinner = false
        Swal.fire({
          iconHtml: ' <img style="width="240"; height="240" src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: result.message,
          showConfirmButton: false,
          timer: 2000,
        })
        this.showSpinner = false
        window.location.reload();
      } else {

        Swal.fire({
          iconHtml: ' <img style="width="240"; height="240" src="../../../../assets/images/modal-close.svg"  alt="image" >',
          title: result.message,
          showConfirmButton: false,
          timer: 2000,

        })
        this.showSpinner = false
        window.location.reload();

      }
    });
  }


  // ------timer----
  countdownTimeStart(time: string) {

    if (time != null && time != "" && time != undefined && (this.checkOutTime == "" || this.checkOutTime == null)) {
      var x = setInterval(() => {
        const currentDate = new Date();
        const month = currentDate.toLocaleString('default', { month: 'short' });
        const temp = new Date(month + ' ' + currentDate.getDate() + ' ' + currentDate.getFullYear() + ' ' + time);
        this.att_total_hours = parseFloat(this.att_total_hours);
        temp.setHours(temp.getHours() + this.att_total_hours);
        const distance = temp.getTime() - new Date().getTime();
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        const secondsWithZero = seconds < 10 ? "0" + seconds : seconds;
        const minutesWithZero = minutes < 10 ? "0" + minutes : minutes;
        this.shiftRemainingTime = "" + hours + ":" + minutesWithZero + ":" + secondsWithZero;
        //calculate percentage to show in progress
        const secondsForPercentage = (+hours) * 60 * 60 + (+minutes) * 60 + (+secondsWithZero);
        const remainingSeconds = (this.att_total_hours * 60 * 60) - secondsForPercentage;
        const percentage = 100 - ((remainingSeconds / (this.att_total_hours * 60 * 60)) * 100);
        this.percentageInProgress = +percentage.toFixed(2);
        // var percentage = (secondsForPercentage / 32400) * 100;
        // this.percentageInProgress = 100 - +percentage.toFixed(2);
        if (distance < 0) {
          clearInterval(x);
          this.shiftRemainingTime = "00:00:00";
          this.percentageInProgress = 100;
        }
      }, 1000);
    }
    else {
      this.shiftRemainingTime = "00:00:00";
    }
  }

  getData() {
    this.showSpinner = true;
    this.attendanceService.getAttendance(
      this.startdate?.replace(new RegExp('-', 'g'), '/'),
      this.endDate?.replace(new RegExp('-', 'g'), '/'),
      null,
      null
    ).then((value) => {
      this.typeArr = value?.data?.attendance
      this.workingHours = value?.data?.total_hours;
      this.overtime = value?.data?.overtime;
      this.applyDataonAttandace();
      const temp_array: any[] = []
      let indexCount = 0
      let lastDate = ""
      let totalHours = 0
      let singleArray: any[] = []
      value.data.attendance.forEach((x: any) => {
        if (indexCount == 0) {
          totalHours += x.total_hours ?? 0
          lastDate = x.date
          singleArray.push(x)
          if (indexCount == this.typeArr.length - 1) {
            var obj = { "total_hours": totalHours ?? 0, "data": singleArray }
            temp_array.push(obj)
          }
        } else {
          if (x.date == lastDate) {
            totalHours += x.total_hours ?? 0
            singleArray.push(x)
            if (indexCount == this.typeArr.length - 1) {
              var obj = { "total_hours": totalHours ?? 0, "data": singleArray }
              temp_array.push(obj)
            }
          } else {
            var obj = { "total_hours": totalHours ?? 0, "data": singleArray }
            temp_array.push(obj)
            singleArray = []
            lastDate = x.date
            totalHours = 0
            totalHours = x.total_hours ?? 0
            singleArray.push(x)
            if (indexCount == this.typeArr.length - 1) {
              var obj = { "total_hours": totalHours ?? 0, "data": singleArray }
              temp_array.push(obj)
            }
          }
        }

        indexCount++

        if (x.check_in != "" && x.check_in != null) {
          this.checkInDays.push(new Date(x.date).getDate().toString());
          if (this.user?.attandance_type == "BD_Open") {
            if (x?.check_in > "21:00") {
              this.checkInArrayForGraph.push("21:00");
            } else {
              this.checkInArrayForGraph.push(x?.check_in);
            }
          } else {
            if (x?.check_in > "11:00") {
              this.checkInArrayForGraph.push("11:00");
            } else {
              this.checkInArrayForGraph.push(x?.check_in);
            }
          }
        }
        if (x.check_out != "" && x.check_out != null) {
          this.checkOutDays.push(new Date(x.date).getDate().toString());
          if (x.check_out > "21:00") {
            this.checkOutArrayForGraph.push("21:00");
          }
          else {
            this.checkOutArrayForGraph.push(x?.check_out);
          }
        }
      });

      this.typeArr = temp_array


      //graph implementation
      const colors = [
        '#4FDDAD',
        '#4FDDAD',
        '#4FDDAD',
        '#4FDDAD',
        '#4FDDAD',
        '#4FDDAD',
      ];

      const checkInData = this.checkInDays.map((day, index) => ({
        y: moment(`1970-02-01 ${this.checkInArrayForGraph[index]}`).valueOf()
      }));

      const checkOutData = this.checkOutDays.map((day, index) => ({
        y: moment(`1970-02-01 ${this.checkOutArrayForGraph[index]}`).valueOf()
      }));

      /* large line chart */
      const chLine = document.getElementById('chLine');
      this.checkInChartData = {
        labels: this.checkInDays,
        datasets: [
          {
            data: checkInData,
            backgroundColor: 'rgba(79, 221, 173,0.5)',
            borderColor: colors[0],
            borderWidth: 4,
            pointBackgroundColor: colors[0],
            fill: true
          },
        ],


      };

      if (chLine) {
        if (chLine) {
          this.chart(this.checkInChartData)
        }
      }
    });
  }


  applyDataonAttandace() {
    this.showSpinner = false;
    this.stats[0].worked_time = 0;
    this.workingHours = 0;
    this.stats[0].total_short_time = 0;
    this.stats[0].check_in_missed = 0;
    this.stats[0].check_in_late = 0;
    this.overtime = 0
    this.typeArr.forEach((x: any) => {
      const checkin = x?.check_in ?? ''
      const checkout = x?.check_out ?? ''
      const workingHours = x?.total_hours ?? 0
      const date = x?.date
      const leaveCheckDate = date?.replace(new RegExp('/', 'g'), '-')
      const dateOBJ = new Date(date);
      if (this.user?.last_working_date < leaveCheckDate) {
        //  OFF DAY (Sunday)
      } else if (this.user?.joining_date > leaveCheckDate) {
        //  OFF DAY (Sunday)
      } else if (checkin?.length == 0
        && checkout?.length == 0
        && this.dashboardService?.otherOffDays.includes(date)) {
        // OFF DAY
      } else if (dateOBJ?.getDay() == 0 && checkin?.length == 0 && checkout?.length == 0) {
        //  OFF DAY (Sunday)
      } else if (dateOBJ?.getDay() == 6
        && checkin?.length == 0
        && checkout?.length == 0
        && !this.dashboardService.workingSaturdays.includes(date)) {
        //  OFF DAY (Saturday)
      } else if (dateOBJ?.getDay() == 6
        && checkin?.length == 0
        && checkout?.length == 0
        && this.dashboardService?.workingSaturdays.includes(date)
        && this.user.id == 54) {
        //  OFF DAY (Saturday) Farhan (Just need to add extra id check for othhers )
      } else if (this.paidLeaves.includes(leaveCheckDate)) {
        //  Paid Leave (Approved)
      } else if (this.unpaidLeaves.includes(leaveCheckDate)) {
        //  Un Paid Leave (Approved)
      } else if (checkin.length == 0 && checkout.length == 0) {
        // Absent
      } else {
        if (x?.overtime != 0 && x?.overtime > 0) {
          this.overtime += x?.overtime
        }

        // asigning total hours
        // need to get from x attendance obj
        const attendance_total_hours = x.total_working_hours;
        const attendance_shift_start = x.shift_start_time;
        const attendance_shift_end = x.shift_end_time;
        let perDayWorkingHour = this.user?.total_working_hours ?? 0;
        if (attendance_total_hours == null) {
          perDayWorkingHour = this.user?.total_working_hours ?? 0;
        } else {
          perDayWorkingHour = attendance_total_hours ?? 0
        }
        this.workingHours += perDayWorkingHour;
        this.stats[0].worked_time += workingHours;
        if (checkin?.length == 0) {
          //Check in Miss
          this.stats[0].check_in_missed += 1;
        }
        if (checkout?.length == 0) {
          //Check Out Miss
        }
        if (workingHours > 0 && workingHours < perDayWorkingHour) {
          //Short Time
          const shrtH = Number((perDayWorkingHour - workingHours).toFixed(2));
          this.stats[0].total_short_time += shrtH;
        }
        if (this.user?.attandance_type != "BD_Open") {
          if (attendance_shift_start == null) {
            this.initialTime = this.user?.shift_start_time;
          } else {
            this.initialTime = attendance_shift_start;
          }
          const startTimeLimit = calculateUpdatedTime(this.initialTime);
          if (checkin > startTimeLimit) {
            //Check In Late
            this.stats[0].check_in_late += this.dashboardService.getLateCheckInTime(checkin, this.user.id);
          }
        }
      }
    });

    if (this.filterType.length > 0) {
      this.applyTypefilter(this.filterType);
    }
  }
  applyTypefilter(filter: string) {
    const tmp_typeArr: any = [];
    this.typeArr.forEach((x: any) => {
      const checkin = x?.check_in ?? ''
      const checkout = x?.check_out ?? ''
      const workingHours = x?.total_hours ?? 0
      const date = x?.date
      const leaveCheckDate = date.replace(new RegExp('/', 'g'), '-')
      const dateOBJ = new Date(date);
      switch (filter) {
        case "Sunday":
          if (dateOBJ.getDay() == 0 && checkin?.length == 0 && checkout?.length == 0) {
            tmp_typeArr.push(x)
          }
          break;
        case "Saturday":
          if (dateOBJ.getDay() == 6
            && checkin?.length == 0
            && checkout?.length == 0
            && !this.dashboardService.workingSaturdays.includes(date)) {
            //  OFF DAY (Saturday)
            tmp_typeArr.push(x)
          }
          break;
        case "Paid Leave":
          if (this.paidLeaves.includes(leaveCheckDate)) {
            tmp_typeArr.push(x)
          }
          break;
        case "Unpaid Leave":
          if (this.unpaidLeaves.includes(leaveCheckDate)) {
            tmp_typeArr.push(x)
          }
          break;
        case "Absent":
          if (checkin?.length == 0 && checkout?.length == 0
            && !this.unpaidLeaves.includes(leaveCheckDate)
            && !this.paidLeaves.includes(leaveCheckDate)
            && (!this.dashboardService.workingSaturdays.includes(date) && dateOBJ.getDay() != 6)
            && (dateOBJ.getDay() != 0)) {
            tmp_typeArr.push(x)
          }
          break;
        case "Check in Miss":
          if (checkin?.length == 0) {
            tmp_typeArr.push(x)
          }
          break;
        case "Check Out Miss":
          if (checkout?.length == 0) {
            tmp_typeArr.push(x)
          }
          break;
        case "Short Time":
          if (workingHours > 0 && workingHours < 9) {
            tmp_typeArr.push(x)
          }
          break;
        case "Check In Late":
          if (this.user?.attandance_type != "BD_Open") {
            const initialTime = this.user?.shift_start_time;
            const startTimeLimit = calculateUpdatedTime(initialTime);
            if (checkin > startTimeLimit) {
              tmp_typeArr.push(x)
            }
          }
          break;
      }
    });

    this.typeArr = tmp_typeArr;
  }

  onSubmit(f: NgForm) {
    if (f?.value?.startdate != null && f?.value?.startdate?.length > 0) {
      this.startdate = f?.value?.startdate
    }

    if (f?.value?.enddate != null && f?.value?.enddate?.length > 0) {
      this.endDate = f?.value?.enddate;
    }

    if (f?.value?.attendancetype != null && f?.value?.attendancetype?.length > 0) {
      this.filterType = f?.value?.attendancetype
      if (this.filterType == "LastMonth") {
        var date = new Date();
        this.startdate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth() - 1, 1), 'yyyy-MM-dd');
        this.endDate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth(), 0), 'yyyy-MM-dd');
        this.filterType = ""
      } else if (this.filterType == "ThisMonth") {
        var date = new Date();
        this.startdate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd');
        this.endDate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth() + 1, 0), 'yyyy-MM-dd');
        this.filterType = ""
      }
    }


    this.getLeaves();
  }

  onReset(f: NgForm) {
    this.showSpinner = true;
    f.reset();
    const date = new Date();
    this.startdate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd');
    this.endDate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth() + 1, 0), 'yyyy-MM-dd');
    this.filterType = ""
    this.getLeaves();
  }
  calculateDiff(data_1: any, data_2: any) {
    const date1 = new Date(data_1);
    const date2 = new Date(data_2);

    const days = Math.floor(
      (date2.getTime() - date1.getTime()) / 1000 / 60 / 60 / 24
    );
    return days + 1;
  }
  getLeaves() {
    this.showSpinner = true;
    this.leaveService.getLeaveFilter(
      this.startdate,
      this.endDate,
      null,
      null
    ).then((value) => {
      this.showSpinner = false;
      this.leaves = value?.data;
      this.leaves.forEach(x => {
        if (x?.status == "approved") {
          if (x?.leave_payment_status == "paid") {
            if ((x?.start_date != null || x?.start_date?.length > 0) && (x?.end_date != null || x?.end_date?.length > 0)) {
              var dtt = new Date(x?.start_date)
              var day = dtt.getDate()
              var totalDays = this.calculateDiff(x?.start_date, x?.end_date)
              for (let i = 0; i < totalDays; i++) {
                var str = this.datepipe.transform(dtt.setDate(day + i), 'yyyy-MM-dd')
                this.paidLeaves.push(str)
              }
            } else {

              this.paidLeaves.push(x?.start_date)
            }
          }
          else if (x?.leave_payment_status == "unpaid") {
            if ((x?.start_date != null || x?.start_date?.length > 0) && (x?.end_date != null || x?.end_date?.length > 0)) {
              var dtt = new Date(x?.start_date)
              var day = dtt.getDate()
              var totalDays = this.calculateDiff(x?.start_date, x?.end_date)
              for (let i = 0; i < totalDays; i++) {
                var str = this.datepipe.transform(dtt.setDate(day + i), 'yyyy-MM-dd')
                this.unpaidLeaves.push(str)
              }
            } else {
              this.unpaidLeaves.push(x?.start_date)
            }

          }
        }
      });
      this.getData();
    });
  }
  getAttendanceStats() {
    this.showSpinner = true;
    this.attendanceService.getStatsFilter().then((value) => {
      // alert("here");
      this.showSpinner = false;
      this.stats = value?.data?.result;
      this.overtime = value?.data?.overtime;
      if (this.stats) {
        this.checkStats = true;
      }
    });
  }

  checkTimer() {
    this.showSpinner = true;
    this.dashboardService.getTodayCheckIn().then((value) => {
      this.checkInDate = value?.data?.date;
      this.checkInTime = value?.data?.check_in;
      this.checkOutTime = value?.data?.check_out;
      this.countdownTimeStart(this?.checkInTime);
      localStorage.setItem('time', value?.data?.check_in);
    });
  }

  showCheckInData() {
    const colors = [
      '#4FDDAD',
      '#4FDDAD',
      '#4FDDAD',
      '#4FDDAD',
      '#4FDDAD',
      '#4FDDAD',
    ];

    const checkInData = this.checkInDays.map((day, index) => ({
      y: moment(`1970-02-01 ${this.checkInArrayForGraph[index]}`).valueOf()
    }));

    this.checkInChartData = {
      labels: this.checkInDays,
      datasets: [
        {
          data: checkInData,
          backgroundColor: 'rgba(79, 221, 173,0.5)',
          borderColor: colors[0],
          borderWidth: 4,
          pointBackgroundColor: colors[0],
          fill: true
        }
      ],
    };

    const chLine = document.getElementById('chLine');
    if (chLine) {
      if (chLine) {
        this.chart(this.checkInChartData)
      }
    }

  }

  showCheckOutData() {
    const colors = [
      '#2180FF',
      '#2180FF',
      '#2180FF',
      '#2180FF',
      '#2180FF',
      '#2180FF',
    ];

    const checkOutData = this.checkOutDays.map((day, index) => ({
      y: moment(`1970-02-01 ${this.checkOutArrayForGraph[index]}`).valueOf()
    }));

    /* large line chart */
    this.checkOutChartData = {
      labels: this.checkOutDays,
      datasets: [
        {
          data: checkOutData,
          backgroundColor: 'rgba(33, 128, 255, 0.5)',
          borderColor: colors[1],
          borderWidth: 4,
          pointBackgroundColor: colors[1],
          fill: true
        },
      ],
    };
    const chLine = document.getElementById('chLine');
    if (chLine) {
      new Chart('chLine', {
        type: 'line',
        data: this.checkOutChartData,
        options: {
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                type: 'linear',
                position: 'left',
                ticks: {
                  min: moment('1970-02-01 18:00:00').valueOf(),
                  max: moment('1970-02-01 21:00:00').valueOf(),
                  stepSize: 3.6e+6,
                  beginAtZero: false,
                  callback: value => {
                    const date = moment(value);
                    if (date.diff(moment('1970-02-01 23:59:59'), 'minutes') === 0) {
                      return null;
                    }
                    return date.format('h A');
                  }
                }
              }
            ]
          },
          legend: {
            display: false,
          },
        },
      });
    }
  }


  chart(chartData: any) {
    let start_value = "1970-02-01 08:00:00"
    let end_value = "1970-02-01 11:00:00"

    if (this.user.attandance_type == "BD_Open") {
      start_value = "1970-02-01 18:00:00"
      end_value = "1970-02-01 21:00:00"
    }
    new Chart('chLine', {
      type: 'line',
      data: chartData,
      options: {
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              type: 'linear',
              position: 'left',
              ticks: {
                min: moment(start_value).valueOf(),
                max: moment(end_value).valueOf(),
                stepSize: 3.6e+6,
                beginAtZero: false,
                callback: value => {
                  const date = moment(value);
                  if (date.diff(moment('1970-02-01 23:59:59'), 'minutes') === 0) {
                    return null;
                  }
                  return date.format('h A');
                }
              }
            }
          ]
        },
        legend: {
          display: false,
        },
      },
    });
  }

  isSecondShiftEmployee() {
    if (this.user.attandance_type == "Open") {
      return false
    } else if (this.user.attandance_type == "BD_Open") {
      return false
    }
    return false
  }
  user_detail() {
    this.showSpinner = true;

    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value?.data;
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }
}
